import { useContext } from 'react';
import { ToastNotificationsControlContext } from './ToastNotificationsControlContext';

/**
 * A hook to retrieve toast notifications control.
 */
export const useToastNotificationsControl = () => {
  const toastNotifications = useContext(ToastNotificationsControlContext);

  return toastNotifications;
};
